// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {
  MDBCol, MDBRow, MDBTable, MDBTableBody,
} from 'mdbreact';
import ApplicantCard from '../../layout/contractorCards/ApplicantCardDetails';

const AppliedContractorDetails = ({
  userType,
  applicants,
  currentWorkOrder,
  setCurrentApplicants,
  toggleModal,
  assignContractor,
}) => (
  (applicants && applicants.contractor)
    ? (
      <MDBRow style={{ marginBottom: '0px' }}>
        <MDBCol>
          <h6 style={{ fontWeight: 'bold' }}>
            Applied Contractor Details
          </h6>
          <div>
            <MDBRow style={{ marginBottom: '15px' }} />
            <MDBRow>
              <MDBCol>
                <MDBTable className="applicantappiliedwo_table">
                  {
                    (applicants && applicants.contractor)
                      && (
                        <MDBTableBody>
                          {
                            applicants.contractor.map(contractor => (
                              contractor.contractor_details
                                ? (
                                  <ApplicantCard
                                    userType={userType}
                                    key={contractor.contractor_details.unique_id}
                                    contractorInfo={contractor}
                                    setCurrentApplicants={setCurrentApplicants}
                                    toggleModal={toggleModal}
                                    currentWorkOrder={currentWorkOrder}
                                    assignContractor={assignContractor}
                                  />
                                )
                                : null
                            ))
                          }
                        </MDBTableBody>
                      )
                  }
                </MDBTable>
              </MDBCol>
            </MDBRow>
          </div>
        </MDBCol>
      </MDBRow>
    )
    : null
);

export default AppliedContractorDetails;
